<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="custName"
      placeholder="输入客户进行查找"
      ref="searchBar"
    />
    <scroll-list @refresh="onSearch">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="{name: 'B2BCustomerBillDetail', params: { item }}"
      >
        <div class="weui-cell__bd">
          <p>{{item.bd_pr_detail}}</p>
          <p class="list-item-muted">{{item.bd_pr_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'#,##0.'">{{item.bd_pi_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.bd_bill_status!='已对账'}"
          >{{item.bd_bill_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('pi_total')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  data() {
    return {
      items: [],
      listUrl: "/api/purchase/purchaseBill/customerBillDetailList"
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name == 'B2BCustomerBillList') {
        vm.onSearch(to.params.item);
      }
    });
  },
  methods: {
    onSearch(item) {
      var me = this

      me.$loading({
        url: me.listUrl,
        method: 'POST',
        jsonData: item
      }).then(function (res) {
        if (res.success) {
          me.items = res.data || []
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  }

};
</script>